export const api = {
  /* URL */

  url: 'https://panel.enhora.app/api/',

  /* LOGIN */
  login: 'login',

  /* WORKER */
  worker: 'worker',
  companysWorker: 'companys-worker/',
  workerId: 'worker/',
  workerData: 'worker-Com/',
  workerHoliday: 'worker-holidays',

  /* CHECK */
  checkIn: 'check-in',
  checkOut: 'check-out',

  /* PAUSE */
  pauseIn: 'pause-in',
  pauseOut: 'pause-out',

  /* WORKER TIMES */
  workerTimes: 'worker-times/',

  /* COMPANYS WORKER */
  companyId: 'companyId/',

  /* HOSTNAME */
  hostname: 'hostname',


 };